var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox } from 'syf-component-library/ui/atoms';
import theme from '../../../theme';
import styled from 'styled-components';
import { Analytics } from '../../../helpers/analyticsMiddleware';
import Icon from '../Icon';
var CheckIcon = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), theme.colors.white);
var TableListCheckbox = function (_a) {
    var selected = _a.selected, onChange = _a.onChange;
    return (_jsx(Checkbox, { dataAnalytics: "clicktrackingevent", dataObject: "check box", dataReason: !selected ? 'select' : 'unselect', dataType: Analytics.RecurringTransactions, icon: selected ? _jsx(CheckIcon, { name: "faCheck" }) : null, isChecked: selected, onChange: onChange, size: 24 }));
};
export default TableListCheckbox;
var templateObject_1;
//# sourceMappingURL=TableListCheckbox.js.map